"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var XIcon = function XIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    width: "18",
    height: "18",
    viewBox: "0 0 18 18"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58581 9.00009L0.878709 2.29298C0.488184 1.90246 0.488184 1.26929 0.878709 0.87877C1.26923 0.488245 1.9024 0.488245 2.29292 0.87877L9.00003 7.58588L15.7071 0.87877C16.0977 0.488245 16.7308 0.488245 17.1213 0.87877C17.5119 1.26929 17.5119 1.90246 17.1213 2.29298L10.4142 9.00009L17.1213 15.7072C17.5119 16.0977 17.5119 16.7309 17.1213 17.1214C16.7308 17.5119 16.0977 17.5119 15.7071 17.1214L9.00003 10.4143L2.29292 17.1214C1.9024 17.5119 1.26923 17.5119 0.878709 17.1214C0.488184 16.7309 0.488184 16.0977 0.878709 15.7072L7.58581 9.00009Z"
  }));
};
var _default = XIcon;
exports.default = _default;